import React, { createContext, useContext, useState, useCallback, useRef } from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction,
} from "./ui/alert-dialog";
import { AlertTriangle } from "lucide-react";

const ConfirmCtx = createContext(() => Promise.resolve(false));
export const useConfirm = () => useContext(ConfirmCtx);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState({ open: false, opts: {} });
  const resolver = useRef(null);

  const confirm = useCallback(
    (opts = {}) =>
      new Promise((resolve) => {
        resolver.current = resolve;
        setState({ open: true, opts });
      }),
    []
  );

  const settle = (val) => {
    if (resolver.current) { resolver.current(val); resolver.current = null; }
    setState((s) => ({ ...s, open: false }));
  };

  const o = state.opts;
  const danger = o.danger !== false; // default to danger styling

  return (
    <ConfirmCtx.Provider value={confirm}>
      {children}
      <AlertDialog open={state.open} onOpenChange={(v) => { if (!v) settle(false); }}>
        <AlertDialogContent
          data-testid="confirm-dialog"
          className={`rounded-none border-2 ${danger ? "border-[#E63946]" : "border-[#A8C97D]"}`}
        >
          <AlertDialogHeader>
            <AlertDialogTitle className={`font-head tracking-tight flex items-center gap-2 ${danger ? "text-[#E63946]" : "text-[#5E8A1E]"}`}>
              <AlertTriangle size={18} strokeWidth={2} /> {o.title || "Confirmare"}
            </AlertDialogTitle>
            {o.description && (
              <AlertDialogDescription className="whitespace-pre-line text-sm text-zinc-600">
                {o.description}
              </AlertDialogDescription>
            )}
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="confirm-cancel" onClick={() => settle(false)}
              className="rounded-none border border-zinc-300 bg-white text-zinc-700 hover:bg-zinc-100 mt-0">
              {o.cancelText || "Anulează"}
            </AlertDialogCancel>
            {o.altText && (
              <AlertDialogAction data-testid="confirm-alt" onClick={() => settle("alt")}
                className="rounded-none border border-[#5E8A1E] bg-white text-[#5E8A1E] hover:bg-[#F1F7E8]">
                {o.altText}
              </AlertDialogAction>
            )}
            <AlertDialogAction data-testid="confirm-ok" onClick={() => settle(true)}
              className={`rounded-none text-white ${danger ? "bg-[#E63946] hover:bg-[#b91c1c]" : "bg-[#5E8A1E] hover:bg-[#42630F]"}`}>
              {o.confirmText || "Confirmă"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </ConfirmCtx.Provider>
  );
}
